module.exports = __webpack_public_path__ + "img/6-3.3b90fe9c.jpg";